import { Component, OnInit } from '@angular/core';
declare let $: any;

@Component({
  selector: 'app-color-setting',
  templateUrl: './color-setting.component.html',
  styleUrls: ['./color-setting.component.css']
})
export class ColorSettingComponent implements OnInit {
  isColor = 'default';
  constructor() { }

  ngOnInit() {
  }

  // radio choose 

  customerModeChanged(createMode: string) {
    this.isColor = createMode || 'dark';
    $('body').attr('data-default-color', createMode);

    localStorage.setItem('userThemeBackColor', this.isColor);
  }

  // default() {

  //   document.documentElement.style.setProperty('--mainbackground', '#fff');
  //   document.documentElement.style.setProperty('--mainColor', '#205a30');
  //   console.log("default");
  //   // Save the value for next time page is visited.
  //   localStorage.setItem('userThemeBackColor', '#fff');
  // }
  // dark() {


  //   document.documentElement.style.setProperty('--headbackground', '#000');
  //   document.documentElement.style.setProperty('--headColor', '#fff');
  //   document.documentElement.style.setProperty('--asidebackground', '#000');
  //   document.documentElement.style.setProperty('--asideColor', '#fff');
  //   document.documentElement.style.setProperty('--contentbackground', '#fff');
  //   document.documentElement.style.setProperty('--contentColor', '#fff');
  //   document.documentElement.style.setProperty('--listbackground', '#000');
  //   document.documentElement.style.setProperty('--listColor', '#fff');
  //   console.log("dark");
  //   // Save the value for next time page is visited.

  //   localStorage.setItem("headbackground", '#000');
  //   localStorage.setItem("headColor", '#fff');
  //   localStorage.setItem("asidebackground", '#000');
  //   localStorage.setItem("asideColor", '#fff');
  //   localStorage.setItem("contentbackground", '#000');
  //   localStorage.setItem("contentColor", '#fff');
  //   localStorage.setItem("listbackground", '#000');
  //   localStorage.setItem("listColor", '#fff');
  //   // localStorage.setItem('userThemeBackColor', '#000');
  // }
  // // custom 
  // headerBackground(event) {
  //   document.documentElement.style.setProperty('--headbackground', event.target.value);

  //   console.log(event.target.value);
  //   // Save the value for next time page is visited.
  //   localStorage.setItem('headbackground', event.target.value);
  // }
  // headerColor(event) {
  //   // Theme the site!
  //   document.documentElement.style.setProperty('--headColor', event.target.value);
  //   console.log(event.target.value);
  //   // Save the event.target.value for next time page is visited.
  //   localStorage.setItem('headColor', event.target.value);
  // }
  // asideBackground(event) {

  //   document.documentElement.style.setProperty('--asidebackground', event.target.value);

  //   console.log(event.target.value);
  //   // Save the value for next time page is visited.
  //   localStorage.setItem('asidebackground', event.target.value);
  // }
  // asideColor(event) {
  //   // Theme the site!
  //   document.documentElement.style.setProperty('--asideColor', event.target.value);
  //   console.log(event.target.value);
  //   // Save the event.target.value for next time page is visited.
  //   localStorage.setItem('asideColor', event.target.value);
  // }
  // contentBackground(event) {

  //   document.documentElement.style.setProperty('--contentbackground', event.target.value);

  //   console.log(event.target.value);
  //   // Save the value for next time page is visited.
  //   localStorage.setItem('contentbackground', event.target.value);
  // }
  // contentColor(event) {
  //   // Theme the site!
  //   document.documentElement.style.setProperty('--contentColor', event.target.value);
  //   console.log(event.target.value);
  //   // Save the event.target.value for next time page is visited.
  //   localStorage.setItem('contentColor', event.target.value);
  // }
  // listBackground(event) {

  //   document.documentElement.style.setProperty('--listbackground', event.target.value);
  //   console.log(event.target.value);
  //   // Save the value for next time page is visited.
  //   localStorage.setItem('listbackground', event.target.value);
  // }
  // listColor(event) {
  //   // Theme the site!
  //   document.documentElement.style.setProperty('--listColor', event.target.value);
  //   console.log(event.target.value);
  //   // Save the event.target.value for next time page is visited.
  //   localStorage.setItem('listColor', event.target.value);
  // }


  // end 
}
